<lx-loading-spinner i18n-message message="Preparing payment portal..." [loading]="!flywireCheckoutLoaded" shadingColor="rgba(0,0,0,0.5)"></lx-loading-spinner>
<div id="flywire-container"></div>
